import script from "./AddonCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./AddonCategory.vue?vue&type=script&setup=true&lang=js"

import "./AddonCategory.vue?vue&type=style&index=0&id=ec576100&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec576100"]])

export default __exports__